import FiscalSpedContribuicoesService from "@/services/FiscalSpedContribuicoesService";

export const fiscalSpedContribuicoes = {
  namespaced: true,
  state: {},
  actions: {
    getFiscalSpedContribuicoesJobsOData(_, payload) {
      return FiscalSpedContribuicoesService.GetJobsOData(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error)
      );
    },
    postFiscalSpedContribuicoesJob(_, payload) {
      return FiscalSpedContribuicoesService.PostJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteFiscalSpedContribuicoesJob(_, payload) {
      return FiscalSpedContribuicoesService.DeleteJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    downloadFiscalSpedContribuicoesJob(_, payload) {
      return FiscalSpedContribuicoesService.DownloadJob(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error)
      );
    },
    getFiscalSpedContribuicoesFiltros() {
      return FiscalSpedContribuicoesService.GetFiltros().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getFiscalSpedContribuicoesConfiguracoes() {
      return FiscalSpedContribuicoesService.GetConfiguracoes().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putFiscalSpedContribuicoesConfiguracoes(_, payload) {
      return FiscalSpedContribuicoesService.PutConfiguracoes(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    getFiscalSpedContabilista() {
      return FiscalSpedContribuicoesService.GetContabilista().then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
    putFiscalSpedContabilista(_, payload) {
      return FiscalSpedContribuicoesService.PutContabilista(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default fiscalSpedContribuicoes;
